import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { ref, unref, onMounted, nextTick, onBeforeUnmount, watch } from 'vue-demi';

export default function useSwiper({ el, paginationEl, options }) {
    const swiperIns = ref(null);

    const initSwiper = () => {
        const [$el, $paginationEl] = [unref(el), unref(paginationEl)];

        const { loop, autoplay, autoplayDelay, slidesPerView, spaceBetween, slides, centeredSlides } = options.value;

        // 无内容不初始化
        if (!slides.length) {
            return;
        }

        // 延迟时间（提供是配置单位是s）
        const delay = autoplayDelay * 1000;

        swiperIns.value = new Swiper($el, {
            modules: [Autoplay, Pagination],
            loop,
            centeredSlides,
            slidesPerView,
            spaceBetween,
            autoplay: autoplay && { delay, disableOnInteraction: false },
            pagination: {
                el: $paginationEl
            }
        });
    };

    const destroySwiper = () => {
        swiperIns.value?.destroy();
    };

    watch(options, () => {
        destroySwiper();
        nextTick(initSwiper);
    });

    onMounted(() => {
        initSwiper();
    });

    onBeforeUnmount(() => {
        destroySwiper();
    });

    return {
        swiper: swiperIns
    };
}
